import React from 'react'
import { NavLink } from 'react-router-dom'
const RightIcon = props => {
    return <svg className="ml-2.5 mr-5" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9L5 5L1 1" stroke={props.color? props.color : "#00A09B"} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}
const Breadcrumb = props => {
    return (
        <div className="ml-5 text-sm flex items-center text-primary breadcrumb">
            <NavLink exact activeClassName="font-bold underline text-secondary" to="/">
            Home
          </NavLink>
            <RightIcon />
            <NavLink exact activeClassName="font-bold underline text-secondary" to="/area-of-interest">Area Of Interest</NavLink>
            <RightIcon />
            <NavLink  isActive={(match, location) => {
               // console.log(location.pathname.trim("/").split("/")[1])
               return location.pathname.split("/")[1] === "questionnaire" }} activeClassName="font-bold underline text-secondary" to="/questionnaire">Questionnaire</NavLink>
            <RightIcon />
            <NavLink to="/">Dashboard</NavLink>
        </div>
    )
}


export default Breadcrumb
